import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, switchMap } from 'rxjs/operators';

import {
  loadOrgProfile,
  loadOrgMembers,
  loadOrgReview,
  loadOrgClubs,
  loadOrgChapters,
  loadOrgJobs,
  addOrgReview
} from './organization.actions';
import { OrganizationService } from './organization.service';
import { AuthService } from '../../../core/services/auth.service';
import { of } from 'rxjs';
import { IOrganization } from '../../../shared/models/user/organization';
import { Error403Component } from '../../error-403/error-403.component';
import { RoutingService } from 'src/app/core/services/routing.service';

@Injectable()
export class OrganizationEffects {
  constructor(
    private actions: Actions,
    private service: OrganizationService,
    private auth: AuthService,
    private routing: RoutingService
  ) {}

  loadOrgProfile$ = createEffect(() =>
    this.actions.pipe(
      ofType(loadOrgProfile.init),
      switchMap(({ payload: { id } }) =>
        this.service.getOrgInfo(id).pipe(
          switchMap((payload) => [loadOrgProfile.success({ payload })]),
          catchError((_) => this.handleJobError(_.error, { id }))
        )
      )
    )
  );

  loadOrgMembers$ = createEffect(() =>
    this.actions.pipe(
      ofType(loadOrgMembers.init),
      switchMap(({ payload: { id } }) =>
        this.service.getMembersOrg(id + ``).pipe(
          switchMap((payload) => [
            loadOrgMembers.success({
              payload: { members: payload.members, count: payload.count }
            })
          ])
        )
      )
    )
  );

  loadOrgClubs$ = createEffect(() =>
    this.actions.pipe(
      ofType(loadOrgClubs.init),
      switchMap(({ payload: { id } }) =>
        this.service
          .getClubs(id + ``)
          .pipe(switchMap((payload) => [loadOrgClubs.success({ payload })]))
      )
    )
  );

  loadOrgChapters$ = createEffect(() =>
    this.actions.pipe(
      ofType(loadOrgChapters.init),
      switchMap(({ payload: { id } }) =>
        this.service
          .getChapters(id + ``)
          .pipe(switchMap((payload) => [loadOrgChapters.success({ payload })]))
      )
    )
  );

  loadOrgJobs$ = createEffect(() =>
    this.actions.pipe(
      ofType(loadOrgJobs.init),
      switchMap(({ payload: { id } }) =>
        this.service
          .getJobs(id + ``)
          .pipe(switchMap((payload) => [loadOrgJobs.success({ payload })]))
      )
    )
  );

  loadOrgReview$ = createEffect(() =>
    this.actions.pipe(
      ofType(loadOrgReview.init),
      switchMap(({ payload }) =>
        this.service
          .getReviewOrg(payload)
          .pipe(switchMap((payload) => [loadOrgReview.success({ payload })]))
      )
    )
  );

  addOrgReview$ = createEffect(() =>
    this.actions.pipe(
      ofType(addOrgReview.init),
      switchMap(({ payload }) =>
        this.service
          .addReview(payload)
          .pipe(switchMap((payload) => [addOrgReview.success({ payload })]))
      )
    )
  );

  private handleJobError(error, params) {
    console.log('handleJobError: ', error);

    switch (error?.code) {
      case 403:
        this.routing.goTo403({
          skipLocationChange: true,
          state: { type: Error403Component.Type.Organization, ...params }
        });
        break;
      default:
        this.routing.goTo404({ skipLocationChange: true });
    }

    return of(loadOrgProfile.success({ payload: null }));
  }
}
